"use client";

import { captureException } from "@sentry/nextjs";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function WeaponBuildsError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <div className="container mx-auto px-4 py-16 text-center">
      <h2 className="mb-4 font-bold text-2xl">Something went wrong!</h2>
      <p className="mb-6 text-muted-foreground">
        {error.message || "An error occurred while loading weapon builds."}
      </p>
      <Button onClick={() => reset()}>Try again</Button>
    </div>
  );
}
